<template>
  <div v-if="nfseConfigurations">
    <b-row>
      <b-col lg="5"
        ><Input
          label="Usuário"
          labelBold
          :maxlength="40"
          v-model="nfseConfigurations.webserverUser"
      /></b-col>
      <b-col lg="5"
        ><Input
          label="Senha"
          labelBold
          type="password"
          :maxlength="40"
          v-model="nfseConfigurations.webserverPassword"
      /></b-col>
      <b-col lg="2" class="text-center">
        <b-col><Label>Produção</Label></b-col>
        <b-row>
          <b-col
            ><CheckboxSwitch
              id="production"
              v-model="nfseConfigurations.production"
              :tooltipPosition="'bottom'"
          /></b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="4"
        ><Input
          label="Frase secreta"
          labelBold
          :maxlength="40"
          v-model="nfseConfigurations.webserverSecretPhrase"
      /></b-col>
      <b-col lg="4"
        ><Input
          label="Chave de acesso"
          labelBold
          v-model="nfseConfigurations.webserverAccessKey"
      /></b-col>
      <b-col lg="4"
        ><Input
          label="Chave de autorização"
          labelBold
          v-model="nfseConfigurations.webserverAuthorizationKey"
      /></b-col>
    </b-row>
  </div>
</template>

<script>
import { CheckboxSwitch, Label, Input } from '@/components/Form';
import { mapState } from 'vuex';

export default {
  name: 'WebService',
  components: { Input, CheckboxSwitch, Label },
  computed: {
    ...mapState('nfseConfigurations', ['nfseConfigurations']),
  },
};
</script>

<style>
</style>
